import { createContext, useContext, useState, useCallback } from 'react';
import { CheckCircle2, XCircle, Info, X } from 'lucide-react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success') => {
    const id = Math.random().toString(36).substring(2, 9);
    setToasts(prev => [...prev, { id, message, type }]);
    // Auto-remove after 4 seconds
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 4000);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      {/* Glassmorphism toast stack */}
      <div
        className="fixed bottom-6 right-6 z-[200] flex flex-col gap-3 pointer-events-none"
        style={{ fontFamily: 'Inter, sans-serif' }}
      >
        {toasts.map(toast => (
          <div
            key={toast.id}
            className="pointer-events-auto flex items-center gap-3
                       bg-white/95 backdrop-blur-xl border border-slate-200/60
                       shadow-[0_20px_40px_-10px_rgba(0,0,0,0.2)]
                       rounded-2xl px-5 py-4 min-w-[300px] max-w-sm
                       transform transition-all animate-in slide-in-from-right-8 fade-in duration-300"
          >
            {toast.type === 'success' && <CheckCircle2 className="w-6 h-6 text-emerald-500 flex-shrink-0" />}
            {toast.type === 'error'   && <XCircle       className="w-6 h-6 text-red-500    flex-shrink-0" />}
            {toast.type === 'info'    && <Info           className="w-6 h-6 text-blue-500   flex-shrink-0" />}

            <p className="text-sm font-bold text-slate-800 flex-1">{toast.message}</p>

            <button
              onClick={() => removeToast(toast.id)}
              className="text-slate-400 hover:text-slate-600 transition-colors
                         bg-slate-50 hover:bg-slate-100 p-1 rounded-full"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
